<template>
  <FormGroup v-if="resource" class="mt-2">
    <FormField v-show="coverage" class="sm:col-span-3" field="coverage" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Audience-Größe
              </strong>
              <br />
              <span>
                &#10173; Wie viele Abonnent*innen wären ein wichtiger Reichweiten-Meilenstein für dich?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Die Audience-Größe spiegelt die Gesamtgröße deiner potentiellen Hörer*innen wieder. Ich empfehle hier die relative Reichweite anhand von Format-Abonnent*innen zu erfassen, nicht die absolute nach Downloads oder Wiedergaben, da letztere stark Folgen-abhängig sind.
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.coverage" id="coverage" :class="props['class']" placeholder="Gesamtzahl an Abonnent*innen"/>
      </template>
    </FormField>
    <FormField v-show="throughput" class="sm:col-span-3" field="throughput" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Durchhörquote
              </strong>
              <br />
              <span>
                &#10173; Wie viel Prozent deiner Folgenlänge sollten Hörer*innen idealerweise dran bleiben?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Die durchschnittliche Hörer*innen-Bindung pro Folge spiegelt die relative Absprungrate von Hörer*innen in einzelnen Folgen wieder. Schaue dir für die Erfassung in den Spotify- oder Apple-Analytics an, wann du zuletzt durchschnittlich 50% deiner Audience verloren hast. Der Wert 0 entspräche einem Ausstieg gleich zu Beginn der Folge und 100 erst ganz zum Ende.
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.throughput" id="throughput" :class="props['class']" placeholder="Zahl von 0-100 (Aussteigszeitpunkt relativ zur Folgenlänge)"/>
      </template>
    </FormField>
    <FormField v-show="reputation" class="sm:col-span-3" field="reputation" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Suchvolumen
              </strong>
              <br/>
              <span>
                &#10173; Auf wie viel Prozent möchtest du dein Markenansehen als nächstes steigern?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Das Suchvolumen spiegelt das relative Interesse nach deiner Brand bzw. deinem Format wieder. Bediene dich hier etwa der Auswertung von Google Trends, die das Suchvolumen nach deinem Titel oder deiner Marke erfassen. Der Wert 0 steht für gar keine erkennbaren Suchnachfragen und 100 für den aktuellen Peak an Suchinteresse (relativ zu deinen Zielen und Erfahrungswerten). Da insbesondere bei Google Trends eine Skalen-Einordnung fehlt, arbeite bitte nur mit dem relativen Wert zum Ablesezeitpunkt oder einem Erfahrungswert.
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.reputation" id="reputation" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
    <FormField v-show="expertise" class="sm:col-span-3" field="expertise" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Eingehende Anfragen
              </strong>
              <br/>
              <span>
                 Auf wie viel Prozent möchtest du deine Wahrnehmung als Expert*in steigern?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Eingehende Anfragen spiegeln die relative Menge von eingehenden Anfragen für Interviews, Aufträge und Kooperationen an dich und das Podcast-Team wieder, die unmittelbar mit oder durch das Format realisiert wurden. Der Wert 0 bedeutet, dass du keinerlei eingehende Anfragen verzeichnet hast und 100, dass du eine größtmögliche Menge an Anfragen erhalten hast (relativ zu deinen Erfahrungswerten und deiner Erwartung).
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.expertise" id="expertise" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
    <FormField v-show="monetization" class="sm:col-span-3" field="monetization" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Umsatzentwicklung
              </strong>
              <br />
              <span>
                &#10173; Wie viel Prozent Monetarisierung wären ein wichtiger Umsatz-Meilenstein für dich?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Die Umsatzentwicklung spiegelt die relative Entwicklung von Umsätzen, die unmittelbar mit oder durch den Podcast realisiert wurden. Der Wert 0 bedeutet, dass du keinerlei Veränderung in deinen Einnahmen feststellen konntest und 100, dass du größtmögliche Erfolge in der Umsatzentwicklung erzielen konntest (relativ zu deinen Zielen und Erfahrungswerten).
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.monetization" id="monetization" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
    <FormField v-show="interaction" class="sm:col-span-3" field="interaction" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Austausch mit Hörer*innen
              </strong>
              <br/>
              <span>
                &#10173; Auf wie viel Prozent möchtest du Menge und Qualität deiner Interaktionen steigern?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Der Austausch mit Hörer*innen spiegelt die Zufriedenheit wieder, wie happy du mit der Menge und Qualität der Konversationen bist. Der Wert 0 bedeutet, dass du keine Anfragen erhältst oder so gar nichts für dich rausziehen kannst und 100, dass die Interaktionen und Rückmeldungen dir denkbar viel geben (relativ zu deinen Zielen und Erfahrungswerten).
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.interaction" id="interaction" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
    <FormField v-show="referability" class="sm:col-span-3" field="referability" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Erwähnungen vom Podcast
              </strong>
              <br/>
              <span>
                &#10173; Wie viel Prozent Empfehlbarkeit wären ein wichtiger Meilenstein für dich?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Erwähnungen vom Podcast spiegeln die relative Menge von Erwähnungen deines Formates in sozialen Medien und solchen Kanälen wieder, die du erfassen kannst. Der Wert 0 bedeutet, dass du keinerlei Erwähnungen feststellen konntest und 100, dass du eine größtmögliche Menge an Erwähnungen erzielen konntest (relativ zu deinen Erfahrungswerten und deiner Erwartung).
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.referability" id="referability" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
    <FormField v-show="enjoyment" class="sm:col-span-3" field="enjoyment" :errors="errors">
      <template #label>
        <Tooltip>
          <template #element>
            <span>
              <strong>
                Freude bei der Umsetzung
              </strong>
              <br/>
              <span>
                &#10173; Auf wie viel Prozent möchtest du den Spaßfaktor beim Podcasten und Wachsen steigern?
              </span>
            </span>
            <InformationCircleIcon class="info-icon" />
          </template>
          <template #content>
            <span>
              Freude bei der Umsetzung spiegelt das relative Vergnügen bei der Realisierung von Reichweitenmethoden wieder. Der Wert 0 bedeutet, dass du keinerlei Freude bei der Umsetzung hattest und 100, dass du größtmöglichen Spaß hattest (relativ zu deinen Erfahrungswerten und deiner Erwartung).
            </span>
          </template>
        </Tooltip>
      </template>
      <template #input="props">
        <InputText v-model="resource.enjoyment" id="enjoyment" :class="props['class']" placeholder="Relative Bewertung von 0-100"/>
      </template>
    </FormField>
  </FormGroup>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({resource: Object, errors: Object, metrics: Array});
const coverage = computed(() => props.metrics.includes('coverage'));
const throughput = computed(() => props.metrics.includes('throughput'));
const reputation = computed(() => props.metrics.includes('reputation'));
const expertise = computed(() => props.metrics.includes('expertise'));
const monetization = computed(() => props.metrics.includes('monetization'));
const interaction = computed(() => props.metrics.includes('interaction'));
const referability = computed(() => props.metrics.includes('referability'));
const enjoyment = computed(() => props.metrics.includes('enjoyment'));
</script>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
